<template>
    <span class="t-vue-lbtn" v-html="svg"
        :id="uuid"
        @click="onclick">
    </span>
</template>
<script>

import Icons from '../stuff/icons.json'

export default {
    name: 'LegendButton',
    props: ['id', 'tv_id', 'grid_id', 'ov_id', 'index', 'display',
            'icon', 'config'],
    mounted() {
    },
    computed: {
        base64() {
            return this.icon || Icons[this.file_name]
        },
        svg() {
            if (this.$props.id === 'display') {
                return this.$props.display
                    ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>'
                    : '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>'
            }
            return this.icon || Icons[this.svg_file_name]
        },
        file_name() {
            let id = this.$props.id
            if (this.$props.id === 'display') {
                id = this.$props.display ? 'display_on' : 'display_off'
            }
            return id + '.png'
        },
        svg_file_name() {
            let id = this.$props.id
            if (this.$props.id === 'display') {
                id = this.$props.display ? 'display_on' : 'display_off'
            }
            return id + '.svg'
        },
        uuid() {
            let tv = this.$props.tv_id
            let gr = this.$props.grid_id
            let ov = this.$props.ov_id
            return `${tv}-btn-g${gr}-${ov}`
        },
        data_type() {
            return this.$props.grid_id === 0 ?
                "onchart" : "offchart"
        },
        data_index() {
            return this.$props.index
        }
    },
    methods: {
        onclick(event) {
            this.$emit('legend-button-click', {
                button: this.$props.id,
                anchor: event.currentTarget.getBoundingClientRect().toJSON(),
                type: this.data_type,
                dataIndex: this.data_index,
                grid: this.$props.grid_id,
                overlay: this.$props.ov_id,
            })
        }
    }
}
</script>
<style>
.t-vue-lbtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 20px;
    padding: 0;
    margin-right: 0px;
    z-index: auto;
    pointer-events: all;
    cursor: pointer;
    border-radius: 3px;
    color: inherit;
}
.t-vue-lbtn svg {
    width: 12px;
    height: 12px;
}
.t-vue-lbtn:hover {
    background: rgba(209, 212, 220, 0.4);
}
</style>
